/**
 * 埋点上报工具
 */
import { useUserStore } from '@/store/modules/user'

// 判断是否是trackEvent环境
const isTrackEventENV = !!window.webfunnyEvent

const getUserInfo = () => {
  const userStore = useUserStore()
  const profile = userStore.profile

  return {
    yongHuNiCheng: profile?.nickname || profile?.preferredUsername || '', // 用户昵称
    inviteCode: profile?.inviteCode || '' // 邀请人邀请码
  }
}

const _fn = () => {}

/**
 * 浏览量埋点
 * @param {Object} params 参数
 * @param {String} params.wePageTitle 页面访问标题
 * @param {String} params.pageUrl 页面访问地址
 */
const trackEvent_PV = (params) => {
  const pageTitle = params.wePageTitle
  window
    .webfunnyEvent({
      pro: 40, // 生产环境点位ID
      sit: 38 // 测试环境点位ID
    })
    .trackEvent(
      {
        pageUrl: params.pageUrl, // 页面地址
        wePageTitle: pageTitle, // 页面标题
        ...getUserInfo()
      },
      {
        upNow: false, // 是否立即上报
        pointIdRelation: true, // 开启点位关联
        originField: 'wePageTitle' // 指定字段值关联
      }
    )
}

const returnFn = () => {
  if (!isTrackEventENV) {
    return {
      trackEvent_PV: _fn
    }
  }
  return {
    trackEvent_PV
  }
}

// 导出
export const trackEvent = () => {
  return returnFn()
}
